import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import type { TableFilter } from '@pbt/pbt-ui-components'

import CheckboxListFilter, {
  type CheckboxListFilterProps,
} from '~/components/common/filters/CheckboxListFilter'
import FeatureToggle from '~/constants/featureToggle'
import { getFeatureToggle } from '~/store/reducers/constants'

import { KibSearchableSelect } from './KibSearchableSelect'

export interface StatusFilterProps extends CheckboxListFilterProps {
  selectedStatusFilter?: TableFilter
  statusItems: Array<{ id: string; name: string }>
}

const StatusFilter = ({
  selectedStatusFilter,
  statusItems,
  ...props
}: StatusFilterProps) => {
  const { t } = useTranslation('Common')
  const isInventoryKibFiltersEnabled = useSelector(
    getFeatureToggle(FeatureToggle.INVENTORY_KIB_FILTERS),
  )

  const selectedValues: string[] = Array.isArray(selectedStatusFilter?.value)
    ? selectedStatusFilter.value.map(String)
    : []

  if (!isInventoryKibFiltersEnabled) {
    return <CheckboxListFilter items={statusItems} {...props} />
  }

  return (
    <KibSearchableSelect
      options={statusItems}
      placeholder={t('Common:STATUS')}
      selectedValues={selectedValues}
      onChange={props.onChange}
    />
  )
}

export default StatusFilter
